import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SessionHeartbeatService {
  private warningTimer: any = null;
  private expiryTimer: any = null;
  private tickTimer: any = null;
  private expiresAtMs = 0;
  private readonly WARNING_BEFORE_MS = 60_000; // 60s przed wygaśnięciem

  public sessionExpiring$ = new BehaviorSubject<boolean>(false);
  /** Pozostały czas sesji w ms (aktualizowany co 1s) — do wyświetlenia licznika. */
  public remainingMs$ = new BehaviorSubject<number>(0);
  public modalVisible = false;

  /**
   * Startuje timer sesji.
   * @param expiresAtMs Timestamp (ms) kiedy token wygasa — odczytany z odpowiedzi backendu.
   */
  start(expiresAtMs: number): void {
    if (!expiresAtMs || isNaN(expiresAtMs)) {
      console.warn('SessionHeartbeatService.start() — nieprawidłowa wartość expiresAtMs:', expiresAtMs);
      return;
    }

    this.stop();
    this.expiresAtMs = expiresAtMs;

    // Licznik pozostałego czasu — odświeżany co sekundę.
    this.updateRemaining();
    this.tickTimer = setInterval(() => this.updateRemaining(), 1000);

    const timeUntilExpiry = expiresAtMs - Date.now();
    const timeUntilWarning = timeUntilExpiry - this.WARNING_BEFORE_MS;

    if (timeUntilExpiry <= 0) {
      // Token już wygasł
      this.sessionExpiring$.next(true);
      return;
    }

    if (timeUntilWarning > 0) {
      // Zaplanuj ostrzeżenie 60s przed wygaśnięciem
      this.warningTimer = setTimeout(() => {
        this.sessionExpiring$.next(true);
      }, timeUntilWarning);
    } else {
      // Zostało mniej niż 60s — pokaż ostrzeżenie od razu
      this.sessionExpiring$.next(true);
    }

    // Fail-safe: drugi sygnał w chwili faktycznego wygaśnięcia
    this.expiryTimer = setTimeout(() => {
      this.sessionExpiring$.next(true);
    }, timeUntilExpiry);
  }

  private updateRemaining(): void {
    const remaining = this.expiresAtMs ? Math.max(0, this.expiresAtMs - Date.now()) : 0;
    this.remainingMs$.next(remaining);
  }

  stop(): void {
    clearTimeout(this.warningTimer);
    clearTimeout(this.expiryTimer);
    clearInterval(this.tickTimer);
    this.warningTimer = null;
    this.expiryTimer = null;
    this.tickTimer = null;
    this.expiresAtMs = 0;
    this.remainingMs$.next(0);
    this.sessionExpiring$.next(false);
  }

  /** Alias dla kompatybilności wstecznej z auth.service */
  stopHeartbeat(): void {
    this.stop();
  }
}
